/*
 * Process Slate Shopify theme
 * Copyright 2020 Process Creative
 *
 * Version:
 *    1.0.0 - 2020/04/26
 */
'use strict'; //Strict Mode enforced

//Imports

require('core-js/stable');

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

require('../../styles/theme.scss');

require('../../styles/theme.scss.liquid');

require('./../objects/icon/Icon');

require('./../sections/header/Header');

require('./../template/index');

require('./../template/product');

require('./../template/cart');

require('./../template/collection');

require('./../template/knowledge-topic');

require('./../template/customers/LoginRegister');

require('./../template/customers/Addresses');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }